import { Vue, Component } from 'vue-property-decorator';
import { MHTTPCL } from "../../services/http/http-client";
export const DISTRIBUTION_URL = '/distribution.pl';
@Component
export default class BandCamp extends Vue {
    bandCampResponse = { ordersArray: [] };
    loadingGif = true;
    onClickBandCamp() {
        this.$emit('onClick', { show: true });
    }
    async mounted() {
        const bandCampData = await MHTTPCL.get(DISTRIBUTION_URL, {
            section: "orders",
            action: "get_orders_from_bandcamp"
        });

        console.log(bandCampData, "bandCampData");
        const objKeyArray = Object.keys(bandCampData.data.response);
        console.log("bandCampData :::", objKeyArray);
        const objKey = objKeyArray[0];
        let bandCampResponse = { ...bandCampData.data.response[objKey] };
        bandCampResponse = {
            ...bandCampResponse,
            ordersArray: [...Object.values(bandCampResponse.orders)],
        };
        console.log(bandCampResponse, "bandCampData");
        this.loadingGif = false;
    }
    render(createElement) {
        return (
            <button
                onClick={this.onClickBandCamp}
                style="min-width: 150px"
                class="dt-button v5 s8"
            >
                {this.loadingGif ?
                    <img src="static/icons/loading.gif" />
                    : `GET BANDCAMP ORDERS(${this.bandCampResponse?.ordersArray?.length})`}

            </button>
        );
    }
}

// const a = {
//     name: 'BandCamp',
//     template: ` <button
//     onClick={this.onClickBandCamp}
//     style="min-width: 150px"
//     class="dt-button v5 s8"
// >
//     {this.loadingGif ?
//         <img src="static/icons/loading.gif" />
//         : GET BANDCAMP ORDERS(${this.bandCampResponse?.ordersArray?.length})}

// </button>`,
//     data: {
//         bandCampResponse: { ordersArray: [] },
//         loadingGif: true
//     },
//     script: `async mounted() {
//         const bandCampData = await MHTTPCL.get(DISTRIBUTION_URL, {
//             section: "orders",
//             action: "get_orders_from_bandcamp"
//         });

//         console.log(bandCampData, "bandCampData");
//         const objKeyArray = Object.keys(bandCampData.data.response);
//         console.log("bandCampData :::", objKeyArray);
//         const objKey = objKeyArray[0];
//         let bandCampResponse = { ...bandCampData.data.response[objKey] };
//         bandCampResponse = {
//             ...bandCampResponse,
//             ordersArray: [...Object.values(bandCampResponse.orders)],
//         };
//         console.log(bandCampResponse, "bandCampData");
//         this.loadingGif = false;
//     },
//     methods:{
//         onClickBandCamp() {
//             this.$emit('onClick', { show: true });
//         }
//     }
//     `

// }

export function waitForExistence(getValueFunction, maxTries = 10, timeInterval = 200) {
    return new Promise((resolve, reject) => {
        let tries = 0
        const interval = setInterval(() => {
            tries += 1
            const value = getValueFunction()
            if (value) {
                clearInterval(interval)
                return resolve(value)
            }

            if (tries >= maxTries) {
                clearInterval(interval)
                return reject(new Error(`Could not find any value using ${tries} tentatives`))
            }
        }, timeInterval)
    })
}
export const PluginData = {
    name: 'PluginData',
    template: `<div></div>`,
    script: `window.PluginData={
        async mounted() {
            const confirmationResult = await window.confirmMessage(
                this.$t('client_settings'),
                "Turn on Project Management Label"
              );
              if (confirmationResult === "OK") {
                const proAgencyData = await window.HttpClient.get('/plugins.pl', {
                    section: "plugins",
                    action: "updateClientConf",
                    column:"settings_label_projects",
                    value:1
                });
        
              }
            },
            }
        `

}
export const PLUGIN_1425 = {
    name: 'PLUGIN_1425',
    template: 
    `<div>
    <v-dialog v-model="pluginFlag" persistent width="600">
    <Modal :id="'catalog-plugins-check_label'" @cancelled="onCancel">
      
        <template slot="body">
            <div class="body-container"> 
            <div  v-if="!showConfirm" style="width:100%;" >
                <img  title="labelcamp" src="static/icons/labelcamp.png" />
            </div>
      
                <ng-container v-if="showConfirm">
                    <div>
                        {{$t("success_msg_idol_products_to_add")}}
                    </div>
                </ng-container>
            </div>
        </template>

        <template slot="options">
            <button class="dt-button  s6" @click.stop="onCancel">
                {{ $t("cancel") }}
            </button>
           
            <button :disabled="!isFormValid"
            :class="{ disabled: !isFormValid }"  @click="onOkClick" class="dt-button v1 s6">
                <template v-if="loadingCatalogGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{$dft.snakeCaseToWords($t("get_cataloque"))  }}
                </template>
            </button>

        </template>
    </Modal>
</v-dialog>
</div>`,
    script:`window.PLUGIN_1425 = {
        data() {
            return {
                URL: '/label.pl',
                loadingCatalogGif: false,
                pluginFlag: true,
                showConfirm: false,
                isFormValid:true
            }
        },

        methods: {
            onOkClick: async function () {
                this.loadingCatalogGif = true;
                let res = await window.HttpClient.post(this.URL, {
                    section: "plugin",
                    action: "get_idol_products",
                    collection_role: "all"
                });
                this.loadingCatalogGif = false;
                if (res.data.status.success) {
                    this.showConfirm = true;
                    this.isFormValid=false;
                }
                else {
                    this.showConfirm = false;
                    this.isFormValid=true;
                }

            },
            onCancel: async function () {
                this.pluginFlag = false;

            },
        }
    }`


}
export const PLUGIN_863 = {
    name: 'PLUGIN_863',
    template: 
    `<div>
    <v-dialog v-model="pluginFlag" persistent width="600">
    <Modal :id="'catalog-plugins-check_label'" @cancelled="onCancel">
      
        <template slot="body">
            <div class="body-container"> 
            <div  v-if="!showConfirm" style="width:100%;" >
                <img  title="labelcamp" src="static/icons/labelcamp.png" />
            </div>
      
                <ng-container v-if="showConfirm">
                    <div>
                        {{$t("success_msg_idol_products_to_add")}}
                    </div>
                </ng-container>
            </div>
        </template>

        <template slot="options">
            <button class="dt-button  s6" @click.stop="onCancel">
                {{ $t("cancel") }}
            </button>
           
            <button  :disabled="!isFormValid"
            :class="{ disabled: !isFormValid }" @click="onOkClick" class="dt-button v1 s6">
                <template v-if="loadingCatalogGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{$dft.snakeCaseToWords($t("get_cataloque"))  }}
                </template>
            </button>

        </template>
    </Modal>
</v-dialog>
</div>`,
    script:`window.PLUGIN_863 = {
        data() {
            return {
                URL: '/label.pl',
                loadingCatalogGif: false,
                pluginFlag: true,
                showConfirm: false,
                isFormValid:true,
            }
        },

        methods: {
            onOkClick: async function () {
                this.loadingCatalogGif = true;
                let res = await window.HttpClient.post(this.URL, {
                    section: "plugin",
                    action: "get_idol_products",
                });
                this.loadingCatalogGif = false;
                if (res.data.status.success) {
                    this.showConfirm = true;
                    this.isFormValid=false;
                }
                else {
                    this.showConfirm = false;
                    this.isFormValid=true;
                }

            },
            onCancel: async function () {
                this.pluginFlag = false;

            },
        }
    }`


}
export const _PLUGINDATA_694 = {
    name: "PluginData",
    template: `<div>
    <v-dialog v-model="pluginFlag" persistent width="990">
    <Modal :id="'catalog-plugins-check_label'" @cancelled="onCancel">
        <template v-if="showConfirm" slot="header">Info</template>
        <template v-if="showLabel" slot="header">Labels</template>
        <template v-if="showFormats" slot="header">Formats</template>
        <template slot="body">
            <div class="body-container">
                <template v-if="showMetaDataUpload">
                    <div style="margin-bottom: 8px">
                        <button style="margin:20px 0px" class="dt-button v5 s8" @click="onChooseFileClick">
                            {{ file ? file.name : $t("Choose File") }}
                        </button>
                        <input type="file" name="cost_file" id="cost_file" style="visibility: hidden; display: none"
                            @change="onFilePickerChange" />
                    </div>
                    <div class="ut-flex">

                        <button :disabled="!file" :class="{ disabled: !file }" @click="onOkClick" class="dt-button v1 s6">

                            <template v-if="loadingFlag">
                                <img src="static/icons/loading.gif" />
                            </template>
                            <template v-else> {{ $t("Upload Meta") }}
                            </template>
                        </button>

                    </div>
                </template>
                <template v-if="showLabel">
                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="new_labels" :config="tableConfig"
                        :headers="headerLabels" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>
                                <td :title="item.label_name" v-bind="tdcon('labels')">
                                    <div>
                                        <span class="txtov"> {{ item.label_name }}</span>

                                    </div>
                                </td>
                                <td v-bind="tdcon('label')">
                                    <Dropdown2 :bb="'0px'" deselect class="dbox1" :showLabel="false" :placeholder="'label'"
                                        :disabled="false" v-on:selectedChange="(e) => onLabelChange('label_id', e, item)
                                            " :options="labelsTV || []" :selected="labelsTV.find((e) => e.value == item.label_id
    )" />
                                </td>



                            </tr>
                        </template>
                    </NTable>

                </template>
                <template v-if="showFormats">

                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="new_formats" :config="tableConfig"
                        :headers="headerFormats" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>
                                <td :title="item.format_name" v-bind="tdcon('formats')">
                                    <div>
                                        <span class="txtov"> {{ item.format_name }}</span>

                                    </div>
                                </td>
                                <td v-bind="tdcon('format')">
                                    <Dropdown2 :bb="'0px'" class="dbox1" :showLabel="false" :placeholder="'format'"
                                        :disabled="false" v-on:selectedChange="(e) => onFormatChange('format_id', e, item)
                                            " :options="formats || []" :selected="formats.find((e) => e.value == item.format_id
    )" />
                                </td>



                            </tr>
                        </template>
                    </NTable>

                </template>
                <template v-if="showProducts">

                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="products" :config="tableConfig"
                        :headers="headers" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>
                                <td :title="item.product.alt_artist" v-bind="tdcon('products')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.alt_artist }}</span>
                                </td>
                                <td :title="item.product.alt_title" v-bind="tdcon('alt_title')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.alt_title }}</span>
                                </td>
                                <td :title="item.product.version" v-bind="tdcon('version')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.version }}</span>

                                </td>
                                <td :title="item.product.catalog_no" v-bind="tdcon('catalog_no')">
                                    <span :style="{
                                        'color': item.product.product_id > 0? 'red' : '',
                                    }" class="txtov"> {{ item.product.catalog_no }}</span>

                                </td>
                                <td :title="item.product.barcode" v-bind="tdcon('barcode')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.barcode }}</span>

                                </td>
                                <td :title="item.product.format_name" v-bind="tdcon('format_name')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.format_name }}</span>

                                </td>
                                <td v-bind="tdcon('New')">
                                    <div class="checkbox-container">
                                        <div style="margin-left:0" class="dt-checkbox v2 s1">
                                            <input type="checkbox" :name="item.ri_id" :id="item.ri_id"
                                                :checked="select_products.has(item.ri_id)" @click="(e) => onCheckboxChange(e, 'ri_id', item)
                                                    " />
                                            <div class="checkmark"></div>
                                        </div>
                                    </div>
                                </td>
                                <td v-bind="tdcon('Tracks')">
                                    <div v-if="item.product.product_id > 0 && item.product.track_count == 0"
                                        class="checkbox-container">
                                        <div style="margin-left:0" class="dt-checkbox v2 s1">
                                            <input type="checkbox" :name="item.product.product_id"
                                                :id="item.product.product_id"
                                                :checked="select_product_tracks.has(item.ri_id)" @click="(e) => onProductTrackCheckboxChange(e, 'product_id', item)
                                                    " />
                                            <div class="checkmark"></div>
                                        </div>
                                    </div>
                                </td>


                            </tr>
                        </template>
                    </NTable>

                </template>
                <template v-if="showTracks">
                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="tracks" :config="tableConfig"
                        :headers="headerTracks" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>

                                <td :style="{
                                    'color': item.track_id > 0  ? 'red' : '',
                                }" :title="item.artist" v-bind="tdcon('tracks')">
                                    <span class="txtov"> {{ item.artist }}</span>
                                </td>
                                <td :style="{
                                    'color': item.track_id > 0  ? 'red' : '',
                                }" :title="item.title" v-bind="tdcon('m_title')">
                                    <span class="txtov"> {{ item.title }}</span>
                                </td>
                                <td :style="{
                                    'color': item.track_id > 0  ? 'red' : '',
                                }" :title="item.version" v-bind="tdcon('version')">
                                    <span class="txtov"> {{ item.version }}</span>

                                </td>
                                <td :style="{
                                    'color': item.track_id > 0  ? 'red' : '',
                                }" :title="item.playtime" v-bind="tdcon('playtime')">
                                    <span class="txtov"> {{ item.playtime }}</span>

                                </td>
                                <td :style="{
                                    'color': item.track_id > 0  ? 'red' : '',
                                }" :title="item.isrc" v-bind="tdcon('isrc')">
                                    <span class="txtov"> {{ item.isrc }}</span>

                                </td>
                                <td v-bind="tdcon('CreateNew')">
                                    <div class="checkbox-container">
                                        <div style="margin-left:0" class="dt-checkbox v2 s1">
                                            <input type="checkbox" :name="item.track_id" :id="item.track_id"
                                                :checked="select_tracks.has(item.ri_id)" @click="(e) => onTrackCheckboxChange(e, 'ri_id', item)
                                                    " />
                                            <div class="checkmark"></div>
                                        </div>
                                    </div>
                                </td>





                            </tr>
                        </template>
                    </NTable>
                    <div style="margin:5px;">
                        If you want to add existing track to products, please do not un-check red lines.
                        <br />
                        Scroll down to bottom to enable PROCESS Button.
                    </div>
                </template>
                <template v-if="showConfirm">
                    <span>
                        You will be notified at {{ email }}, when the process is complete.
                    </span>
                </template>
            </div>
        </template>

        <template slot="options">
            <button class="dt-button  s6" @click.stop="onCancel">
                {{ $t("cancel") }}
            </button>
            <button :disabled="!isValid" :class="{ disabled: !isValid }" v-if="showFormats" @click="selectedFormats"
                class="dt-button v1 s6">
                <template v-if="loadingFormatGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>
            <button v-if="showProducts" @click="selectedProducts" class="dt-button v1 s6">
                <template v-if="loadingProductGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>
            <button v-if="showTracks" @click="sendTracks" class="dt-button v1 s6">
                <template v-if="loadingTrackGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>
            <button v-if="showLabel" @click="sendLabel" class="dt-button v1 s6">
                <template v-if="loadingLabelGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>

        </template>
    </Modal>
</v-dialog>
</div>`,
    script: `window.PluginData = {
        async mounted() {
            const resData = await window.HttpClient.get(this.URL, {
                action: "get_label_page",
                page: 1,
                rows: 10000,
            });
            this.labelsTV = resData.data.labels.map(p => {
                return {
                    text: p.label_name,
                    value: p.label_id,
                }
            });
        },
        data() {
            return {
                URL: '/jsonapi.pl',
                file: null,
                label_id: 0,
                labelsTV: [],
                loadingFlag: false,
                global_source_id: 0,
                loadingProductGif: false,
                loadingFormatGif: false,
                loadingTrackGif: false,
                new_formats: [],
                new_labels: [],
                formats: [],
                select_formats: [],
                select_products: new Set(),
                select_product_tracks: new Set(),
                select_tracks: new Set(),
                showProducts: false,
                showFormats: false,
                showMetaDataUpload: true,
                loadingLabelGif: false,
                showTracks: false,
                showConfirm: false,
                showLabel: false,
                tracks: [],
                pluginFlag: true,
                tableConfig: window.createNTableConfig({
                    headerStyle: 3,
                }),
                email: "",
                selectedTracks:[]
            };
        },
        computed: {
            isValid: function () {
                return this.new_formats.length === this.new_formats.filter(f => f.format_id > 0).length ? true : false;
            },
            headers: function () {
                return [
                    window.createTableHeader("products", { f: 0.9}),
                    window.createTableHeader("alt_title", { text: false }),
                    window.createTableHeader("version", {mw:60, text: false }),
                    window.createTableHeader("catalog_no", {mw:120, text: false }),
                    window.createTableHeader("barcode", {mw:130, text: false }),
                    window.createTableHeader("format_name", {mw:80, text: false }),
                    window.createTableHeader("New", { mw: 60 }),
                    window.createTableHeader("Tracks", { mw: 60 }),
    
                ];
    
            },
            headerTracks: function () {
                return [
                    window.createTableHeader("tracks", { f: 0.9 }),
                    window.createTableHeader("m_title", { text: false }),
                    window.createTableHeader("version", {mw: 120, text: false }),
                    window.createTableHeader("playtime", {mw: 80, text: false }),
                    window.createTableHeader("isrc", {mw: 120, text: false }),
                    window.createTableHeader("CreateNew", { mw: 120, text: 'Create New/Add' }),
                ];
    
            },
            headerLabels: function () {
                return [
                    window.createTableHeader("labels",),
                    window.createTableHeader("label", { mw: 250, text: false }),
                ];
    
            },
            headerFormats: function () {
                return [
                    window.createTableHeader("formats",),
                    window.createTableHeader("format", { mw: 250, text: false }),
                ];
    
            },
        },
        methods: {
            onFormatChange: function (name, value, item) {
                item[name] = value.value
            },
            onLabelChange: function (name, value, item) {
                item[name] = value.value
            },
            onCheckboxChange: function (event, name, item) {
                const value = event.target.checked;
                this.select_products = window.addRemoveSet(
                    event.target.checked,
                    this.select_products,
                    item.ri_id
                );
    
                console.log('this.select_products', this.select_products)
                console.log('this.item', item)
            },
            onProductTrackCheckboxChange: function (event, name, item) {
                const value = event.target.checked;
                this.select_product_tracks = window.addRemoveSet(
                    event.target.checked,
                    this.select_product_tracks,
                    item.ri_id
                );
            },
            onTrackCheckboxChange: function (event, name, item) {
                const value = event.target.checked;
                this.select_tracks = window.addRemoveSet(
                    event.target.checked,
                    this.select_tracks,
                    item.ri_id
                );
    
                console.log("WWWW", item.ri_id, value);
            },
            onOkClick: async function () {
                if (this.file) {
                    this.loadingFlag = true;
                    let fd = new FormData();
                    fd.append("file", this.file);
                    fd.append("plugin_name", "multilabel-import");
                    fd.append("action", "label_import_file");
                    this.loadingFlag = true;
                    window.HttpClient.postFormData(this.URL, fd)
                        .then((res) => {
                            this.loadingFlag = false;
                            console.log('daaa', res.data);
                            let { source_id, email } = res.data;
                            this.global_source_id = source_id;
                            this.processLabel();
                        })
                        .catch((e) => {
                            this.$emit("cancelled", true);
                        });
                } else {
                    this.$emit("cancelled", true);
                }
            },
            async processLabel() {
    
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_process_label",
                    source_id: this.global_source_id,
                });
                let { new_labels=[], labels=[] } = res.data;
                this.labelsTV = labels.map(p => {
                    return {
                        text: p.label_name,
                        value: p.label_id,
                    }
                });
                this.new_labels = new_labels.map(f => {
                    return {
                        label_name: f,
                        label_id: 0,
                    }
                });
    
                if (this.new_labels.length === 0) {
                    this.loadingFlag = false
                    this.processFormat();
                }
                else {
                    this.showLabel = true;
                    this.showMetaDataUpload = false;
                }
            },
            async sendLabel() {
                this.loadingLabelGif = true;
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_select_labels",
                    source_id: this.global_source_id,
                    labels: JSON.stringify(this.new_labels),
                });
                this.loadingLabelGif = false;
                this.processFormat();
            },
            async processFormat() {
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_process_format",
                    source_id: this.global_source_id,
                });
                let { new_formats, formats=[] } = res.data;
                this.new_formats = [...new_formats];
                this.formats = [...formats];
                if (this.new_formats.length === 0) {
                    this.loadingFlag = false
                    this.processProduct();
                }
                else {
                    this.showMetaDataUpload = false;
                    this.showFormats = true;
                    this.loadingFlag = false;
                    this.showLabel = false;
                    this.formats = this.formats.map(f => {
                        return {
                            text: f.format_name,
                            value: f.format_id,
                        }
                    })
                    this.new_formats = this.new_formats.map(f => {
                        return {
                            format_name: f,
                            format_id: 0,
                        }
                    })
                }
            },
            async selectedFormats() {
                this.loadingFormatGif = true;
                const select_formats = this.new_formats.filter(f => f.format_id > 0)
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_select_formats",
                    source_id: this.global_source_id,
                    formats: JSON.stringify(select_formats),
                });
                this.loadingFormatGif = false;
                this.processProduct();
            },
            async processProduct() {
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_process_product",
                    source_id: this.global_source_id,
                });
                let { products } = res.data;
                this.products = [...products]
                this.showMetaDataUpload = false;
                this.showFormats = false;
                this.showLabel = false;
                this.showProducts = true;
                const select_products = this.products.filter(p => !p.product.product_id).map(p => p.ri_id);
                select_products.forEach(item => {
                    this.select_products.add(item);
                });
            },
            async selectedProducts() {
                this.loadingProductGif = true;
                const selectedProducts = [];
                this.products.forEach(p => {
                    const checkedNP = this.select_products.has(p.ri_id) ? 1 : 0;
                    const checkedNPT = this.select_product_tracks.has(p.ri_id) ? 1 : 0;
                    selectedProducts.push({
                        ri_id: p.ri_id,
                        np: checkedNP,
                        npt: checkedNPT
                    });
                });
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_select_products",
                    source_id: this.global_source_id,
                    products: JSON.stringify(selectedProducts),
                });
    
                this.processTrack();
            },
    
            async processTrack() {
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_process_tracks",
                    source_id: this.global_source_id,
                });
                let { products } = res.data;
                this.showTracks = true;
                this.showProducts = false;
                let tracks = [...products];
    
                tracks.forEach(t => {
                    t.tracks = t.tracks.map((s, index) => {
                        if (index === 0) {
                            s.group_title = t.product.catalog_no + ' | ' + t.product.alt_artist + ' | ' +
                                t.product.alt_title + ' | ' + t.format.format_name
                            s.new_group_title = 1
                        }
    
                        s.period = t.product.catalog_no + ' | ' + t.product.alt_artist + ' | ' +
                            t.product.alt_title + ' | ' + t.format.format_name
                        s = {
                            ...s,
                            ...s.track
                        }
                        return s;
                    });
    
                    this.tracks.push(...t.tracks);
                    this.tracks.forEach(item => {
                        this.select_tracks.add(item.ri_id);
                    })
                });
    
                console.log(' this.tracks', this.tracks);
                this.loadingProductGif = false;
            },
            sendTracks() {
                this.tracks.forEach(p => {
                    const checkedNT = this.select_tracks.has(p.ri_id) ? 1 : 0;
                    this.selectedTracks.push({
                        ri_id: p.ri_id,
                        nt: checkedNT,
    
                    });
                });
                this.sendTrackData();
            },
            sendTrackData() {
                this.loadingTrackGif = true;
                let last_req = 0;
                let track_chunk = [];
                if (this.selectedTracks.length > 1000) {
                    track_chunk = this.selectedTracks.splice(0, 1000);
                    console.log('selectedTracks', this.selectedTracks)
                } else {
                    last_req = 1;
                    track_chunk = this.selectedTracks.splice(0);
                }
                window.HttpClient.post(this.URL, {
                    action: "ri_select_tracks",
                    source_id: this.global_source_id,
                    total_track: track_chunk.length,
                    tracks: JSON.stringify(track_chunk),
                }).then((res) => {
                    if (last_req) {
                        this.confirmImport(res.data);
                    } else {
                        this.sendTrackData();
                    }
                });
    
    
            },
           
            confirmImport(data) {
                let { email } = data;
                window.HttpClient.post(this.URL, {
                    action: "process_multilabel_import",
                    source_id: this.global_source_id,
    
                }, {
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true,
                    },
                }).then((data) => {
                    this.showConfirm = true;
                    this.showTracks = false;
                    this.loadingTrackGif = false;
                    this.email = email;
                });
    
            },
            onCancel: async function () {
                this.pluginFlag = false;
                if (this.global_source_id && !this.showConfirm) {
                    let res = await window.HttpClient.post(this.URL, {
                        action: "cancel_label_import",
                        source_id: this.global_source_id,
                    });
                }
            },
            onFilePickerChange: function (event) {
                const files = event.target.files;
                if (files.length > 0) {
                    this.file = files[0];
                    console.log({ "this.file": this.file });
                }
            },
            onChooseFileClick() {
                document.querySelector("#cost_file").click();
            },
            onDropdownChange(name, value) {
                this.label_id = value.value
            }
            //MARK: Methods
        },
    };`
};
export const _PLUGINDATA_693 = {
    name: "PluginData",
    template: `<div>
    <v-dialog v-model="pluginFlag" persistent width="990">
    <Modal :id="'catalog-plugins-check_label'" @cancelled="onCancel">
        <template v-if="showConfirm" slot="header">Info</template>
        <template v-if="showFormats" slot="header">Formats</template>
        <template slot="body">
            <div class="body-container">
                <ng-container v-if="showMetaDataUpload">
                    <div style="margin-bottom: 8px">
                        <Dropdown class="m2" :options="labelsTV" box :placeholder="$t('label')"
                            v-on:selectedChange="(e) => onDropdownChange('label', e)" :listHeight="250"
                            :selected="labelsTV.find(e => e.value == label_id)" deselect />
                        <button style="margin:20px 0px" class="dt-button v5 s8" @click="onChooseFileClick">
                            {{ file ? file.name : $t("Choose File") }}
                        </button>
                        <input type="file" name="cost_file" id="cost_file" style="visibility: hidden; display: none"
                            @change="onFilePickerChange" />
                    </div>
                    <div class="ut-flex">

                        <button :disabled="!file || !label_id" :class="{ disabled: !file || !label_id }" @click="onOkClick"
                            class="dt-button v1 s6">

                            <template v-if="loadingFlag">
                                <img src="static/icons/loading.gif" />
                            </template>
                            <template v-else> {{ $t("Upload Meta") }}
                            </template>
                        </button>

                    </div>
                </ng-container>
                <ng-container v-if="showFormats">

                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="new_formats" :config="tableConfig"
                        :headers="headerFormats" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>
                                <td v-bind="tdcon('formats')">
                                    <div>
                                        <span class="txtov"> {{ item.format_name }}</span>

                                    </div>
                                </td>
                                <td v-bind="tdcon('format')">
                                    <Dropdown2 :bb="'0px'" class="dbox1" :showLabel="false" :placeholder="'format'"
                                        :disabled="false" v-on:selectedChange="(e) => onFormatChange('format_id', e, item)
                                            " :options="formats || []" :selected="formats.find((e) => e.value == item.format_id
    )" />
                                </td>



                            </tr>
                        </template>
                    </NTable>

                </ng-container>
                <ng-container v-if="showProducts">

                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="products" :config="tableConfig"
                        :headers="headers" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>
                                <td v-bind="tdcon('products')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.alt_artist }}</span>
                                </td>
                                <td v-bind="tdcon('alt_title')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.alt_title }}</span>
                                </td>
                                <td v-bind="tdcon('version')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.version }}</span>

                                </td>
                                <td v-bind="tdcon('catalog_no')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.catalog_no }}</span>

                                </td>
                                <td v-bind="tdcon('barcode')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.barcode }}</span>

                                </td>
                                <td v-bind="tdcon('format_name')">
                                    <span :style="{
                                        'color': item.product.product_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.product.format_name }}</span>

                                </td>
                                <td v-bind="tdcon('New')">
                                    <div class="checkbox-container">
                                        <div style="margin-left:0" class="dt-checkbox v2 s1">
                                            <input type="checkbox" :name="item.ri_id" :id="item.ri_id"
                                                :checked="select_products.has(item.ri_id)" @click="(e) => onCheckboxChange(e, 'ri_id', item)
                                                    " />
                                            <div class="checkmark"></div>
                                        </div>
                                    </div>
                                </td>
                                <td v-bind="tdcon('Tracks')">
                                    <div v-if="item.product.product_id > 0 && item.product.track_count == 0"
                                        class="checkbox-container">
                                        <div style="margin-left:0" class="dt-checkbox v2 s1">
                                            <input type="checkbox" :name="item.product.product_id"
                                                :id="item.product.product_id"
                                                :checked="select_product_tracks.has(item.ri_id)" @click="(e) => onProductTrackCheckboxChange(e, 'product_id', item)
                                                    " />
                                            <div class="checkmark"></div>
                                        </div>
                                    </div>
                                </td>


                            </tr>
                        </template>
                    </NTable>

                </ng-container>
                <ng-container v-if="showTracks">
                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="tracks" :config="tableConfig"
                        :headers="headerTracks" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>

                                <td v-bind="tdcon('tracks')">
                                    <span :style="{
                                        'color': item.track_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.artist }}</span>
                                </td>
                                <td v-bind="tdcon('m_title')">
                                    <span :style="{
                                        'color': item.track_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.title }}</span>
                                </td>
                                <td v-bind="tdcon('version')">
                                    <span :style="{
                                        'color': item.track_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.version }}</span>

                                </td>
                                <td v-bind="tdcon('playtime')">
                                    <span :style="{
                                        'color': item.track_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.playtime }}</span>

                                </td>
                                <td v-bind="tdcon('isrc')">
                                    <span :style="{
                                        'color': item.track_id > 0  ? 'red' : '',
                                    }" class="txtov"> {{ item.isrc }}</span>

                                </td>
                                <td v-bind="tdcon('CreateNew')">
                                    <div class="checkbox-container">
                                        <div style="margin-left:0" class="dt-checkbox v2 s1">
                                            <input type="checkbox" :name="item.track_id" :id="item.track_id"
                                                :checked="select_tracks.has(item.ri_id)" @click="(e) => onTrackCheckboxChange(e, 'ri_id', item)
                                                    " />
                                            <div class="checkmark"></div>
                                        </div>
                                    </div>
                                </td>





                            </tr>
                        </template>
                    </NTable>
                    <div style="margin:5px;">
                        If you want to add existing track to products, please do not un-check red lines.
                        <br />
                        Scroll down to bottom to enable PROCESS Button.
                    </div>
                </ng-container>
                <ng-container v-if="showConfirm">
                    <span>
                        You will be notified at {{ email }}, when the process is complete.
                    </span>
                </ng-container>
            </div>
        </template>

        <template slot="options">
            <button class="dt-button  s6" @click.stop="onCancel">
                {{ $t("cancel") }}
            </button>
            <button :disabled="!isValid" :class="{ disabled: !isValid }" v-if="showFormats" @click="selectedFormats"
                class="dt-button v1 s6">
                <template v-if="loadingFormatGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>
            <button v-if="showProducts" @click="selectedProducts" class="dt-button v1 s6">
                <template v-if="loadingProductGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>
            <button v-if="showTracks" @click="sendTracks" class="dt-button v1 s6">
                <template v-if="loadingTrackGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>

        </template>
    </Modal>
</v-dialog>
</div>`,
    script: `window.PluginData = {
        async mounted() {
            const resData = await window.HttpClient.get(this.URL, {
                action: "get_label_page",
                page: 1,
                rows: 10000,
            });
            this.labelsTV = resData.data.labels.map(p => {
                return {
                    text: p.label_name,
                    value: p.label_id,
                }
            });
        },
        data() {
            return {
                URL: '/jsonapi.pl',
                file: null,
                label_id: 0,
                labelsTV: [],
                loadingFlag: false,
                global_source_id: 0,
                loadingProductGif: false,
                loadingFormatGif: false,
                loadingTrackGif: false,
                new_formats: [],
                formats: [],
                select_formats: [],
                select_products: new Set(),
                select_product_tracks: new Set(),
                select_tracks: new Set(),
                showProducts: false,
                showFormats: false,
                showMetaDataUpload: true,
                showTracks: false,
                showConfirm: false,
                tracks: [],
                pluginFlag: true,
                tableConfig: window.createNTableConfig({
                    headerStyle: 3,
                }),
                email: "",
                selectedTracks: [],
            };
        },
        computed: {
            isValid: function () {
                return this.new_formats.length === this.new_formats.filter(f => f.format_id > 0).length ? true : false;
            },
            headers: function () {
                return [
                    window.createTableHeader("products", { f: 0.9 }),
                    window.createTableHeader("alt_title", { text: false }),
                    window.createTableHeader("version", {mw:60, text: false }),
                    window.createTableHeader("catalog_no", {mw:120, text: false }),
                    window.createTableHeader("barcode", { mw:130,text: false }),
                    window.createTableHeader("format_name", {mw:80, text: false }),
                    window.createTableHeader("New", { mw: 60 }),
                    window.createTableHeader("Tracks", { mw: 60 }),
    
                ];
    
            },
            headerTracks: function () {
                return [
                    window.createTableHeader("tracks", { f: 0.9 }),
                    window.createTableHeader("m_title", { text: false }),
                    window.createTableHeader("version", {mw: 120, text: false }),
                    window.createTableHeader("playtime", {mw: 80, text: false }),
                    window.createTableHeader("isrc", {mw: 120, text: false }),
                    window.createTableHeader("CreateNew", { mw: 120, text: 'Create New/Add' }),
                ];
    
            },
    
            headerFormats: function () {
                return [
                    window.createTableHeader("formats",),
                    window.createTableHeader("format", { mw: 250, text: false }),
    
    
                ];
    
            },
        },
        methods: {
            onFormatChange: function (name, value, item) {
                item[name] = value.value
            },
            onCheckboxChange: function (event, name, item) {
                const value = event.target.checked;
                this.select_products = window.addRemoveSet(
                    event.target.checked,
                    this.select_products,
                    item.ri_id
                );
    
                console.log('this.select_products', this.select_products)
                console.log('this.item', item)
            },
            onProductTrackCheckboxChange: function (event, name, item) {
                const value = event.target.checked;
                this.select_product_tracks = window.addRemoveSet(
                    event.target.checked,
                    this.select_product_tracks,
                    item.ri_id
                );
            },
            onTrackCheckboxChange: function (event, name, item) {
                const value = event.target.checked;
                this.select_tracks = window.addRemoveSet(
                    event.target.checked,
                    this.select_tracks,
                    item.ri_id
                );
    
                console.log("WWWW", item.ri_id, value);
            },
            onOkClick: async function () {
                if (this.file) {
                    this.loadingFlag = true;
                    let fd = new FormData();
                    fd.append("file", this.file);
                    fd.append("label_id", this.label_id);
                    fd.append("plugin_name", "fixlabel-import");
                    fd.append("action", "label_import_file");
                    this.loadingFlag = true;
                    window.HttpClient.postFormData(this.URL, fd)
                        .then((res) => {
                            this.loadingFlag = false;
                            console.log('daaa', res.data);
                            let { source_id, email } = res.data;
                            this.global_source_id = source_id;
                            this.processFormat();
                        })
                        .catch((e) => {
                            this.$emit("cancelled", true);
                        });
                } else {
                    this.$emit("cancelled", true);
                }
            },
            async processFormat() {
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_process_format",
                    source_id: this.global_source_id,
                });
                let { new_formats, formats = [] } = res.data;
                this.new_formats = [...new_formats];
                this.formats = [...formats];
                if (this.new_formats.length === 0) {
                    this.loadingFlag = false
                    this.processProduct();
                }
                else {
                    this.showMetaDataUpload = false;
                    this.showFormats = true;
                    this.loadingFlag = false;
                    this.formats = this.formats.map(f => {
                        return {
                            text: f.format_name,
                            value: f.format_id,
                        }
                    })
                    this.new_formats = this.new_formats.map(f => {
                        return {
                            format_name: f,
                            format_id: 0,
                        }
                    })
                }
            },
            async selectedFormats() {
                this.loadingFormatGif = true;
                const select_formats = this.new_formats.filter(f => f.format_id > 0)
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_select_formats",
                    source_id: this.global_source_id,
                    formats: JSON.stringify(select_formats),
                });
                this.loadingFormatGif = false;
                this.processProduct();
            },
            async processProduct() {
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_process_product",
                    source_id: this.global_source_id,
                });
                let { products } = res.data;
                this.products = [...products]
                this.showMetaDataUpload = false;
                this.showFormats = false;
                this.showProducts = true;
                const select_products = this.products.filter(p => !p.product.product_id).map(p => p.ri_id);
                select_products.forEach(item => {
                    this.select_products.add(item);
                });
            },
            async selectedProducts() {
                this.loadingProductGif = true;
                const selectedProducts = [];
                this.products.forEach(p => {
                    const checkedNP = this.select_products.has(p.ri_id) ? 1 : 0;
                    const checkedNPT = this.select_product_tracks.has(p.ri_id) ? 1 : 0;
                    selectedProducts.push({
                        ri_id: p.ri_id,
                        np: checkedNP,
                        npt: checkedNPT
                    });
                });
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_select_products",
                    source_id: this.global_source_id,
                    products: JSON.stringify(selectedProducts),
                });
    
                this.processTrack();
            },
    
            async processTrack() {
                let res = await window.HttpClient.post(this.URL, {
                    action: "ri_process_tracks",
                    source_id: this.global_source_id,
                });
                let { products } = res.data;
                this.showTracks = true;
                this.showProducts = false;
                let tracks = [...products];
    
                tracks.forEach(t => {
                    t.tracks = t.tracks.map((s, index) => {
                        if (index === 0) {
                            s.group_title = t.product.catalog_no + ' | ' + t.product.alt_artist + ' | ' +
                                t.product.alt_title + ' | ' + t.format.format_name
                            s.new_group_title = 1
                        }
    
                        s.period = t.product.catalog_no + ' | ' + t.product.alt_artist + ' | ' +
                            t.product.alt_title + ' | ' + t.format.format_name
                        s = {
                            ...s,
                            ...s.track
                        }
                        return s;
                    });
    
                    this.tracks.push(...t.tracks);
                    this.tracks.forEach(item => {
                        this.select_tracks.add(item.ri_id);
                    })
                });
    
                console.log(' this.tracks', this.tracks);
                this.loadingProductGif = false;
            },
            sendTracks() {
                this.tracks.forEach(p => {
                    const checkedNT = this.select_tracks.has(p.ri_id) ? 1 : 0;
                    this.selectedTracks.push({
                        ri_id: p.ri_id,
                        nt: checkedNT,
    
                    });
                });
                this.sendTrackData();
            },
            sendTrackData() {
                this.loadingTrackGif = true;
                let last_req = 0;
                let track_chunk = [];
                if (this.selectedTracks.length > 1000) {
                    track_chunk = this.selectedTracks.splice(0, 1000);
                    console.log('selectedTracks', this.selectedTracks)
                } else {
                    last_req = 1;
                    track_chunk = this.selectedTracks.splice(0);
                }
                window.HttpClient.post(this.URL, {
                    action: "ri_select_tracks",
                    source_id: this.global_source_id,
                    total_track: track_chunk.length,
                    tracks: JSON.stringify(track_chunk),
                }).then((res) => {
                    if (last_req) {
                        this.confirmImport(res.data);
                    } else {
    
                        this.sendTrackData();
                    }
                });
    
    
            },
            confirmImport(data) {
                let { email } = data;
                window.HttpClient.post(this.URL, {
                    action: "process_fixlabel_import",
                    source_id: this.global_source_id,
    
                }, {
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true,
                    },
                }).then((data) => {
                    this.showConfirm = true;
                    this.showTracks = false;
                    this.loadingTrackGif = false;
                    this.email = email;
                });
    
            },
            onCancel: async function () {
                this.pluginFlag = false;
                if (this.global_source_id && !this.showConfirm) {
                    let res = await window.HttpClient.post(this.URL, {
                        action: "cancel_label_import",
                        source_id: this.global_source_id,
                    });
                }
            },
            onFilePickerChange: function (event) {
                const files = event.target.files;
                if (files.length > 0) {
                    this.file = files[0];
                    console.log({ "this.file": this.file });
                }
            },
            onChooseFileClick() {
                document.querySelector("#cost_file").click();
            },
            onDropdownChange(name, value) {
                this.label_id = value.value
            }
            //MARK: Methods
        },
    };`
};
export const _PLUGINDATA2 = {
    name: "PluginData",
    template: `<div>
    <button class="dt-button v5 s8" @click="onAddProAgency">
            {{ $t("pro_agency_btn") }}
          </button>
    <v-dialog v-model="pluginFlag" persistent width="420">
    <Modal :id="'cpm-catalaog-releases-pro_agency'" :loading="loading" @cancelled="onCancel">
        <template slot="header">{{ $t('pro_agency_delivery') }}</template>

        <template slot="body">
            <div class="form-group">
                <Dropdown :options="api_accountsTV" :id="'api_account'" class="m2"
                    :selected="api_accountsTV.find(e => e.value == api_account)" :placeholder="$t('api_account')"
                    @selectedChange="e => onDropdownChange('api_account', e)" box :listHeight="250"></Dropdown>
                <Dropdown :options="labelsTV" :id="'pro_agency_account'" class="m2"
                    :selected="labelsTV.find(e => e.value == label_filter_id)" :placeholder="$t('pro_agency_account')"
                    @selectedChange="e => onDropdownChange('label_filter_id', e)" box :listHeight="250"></Dropdown>
                <div class="checkbox-container">
                    <div style="height:20px;" class="dt-checkbox-control">
                        <div style="margin-top:5px;margin-top: 3px;margin-right:0px;margin-left: 0px;"
                            class="dt-checkbox v2 s1">
                            <input tabindex="-1" type="checkbox" @change="changeCheckbox"
                                v-model="all_undelivered" name="all_undelivered" id="all_undelivered"
                                class="checkbox-input" />
                            <div tabindex="0" class="checkmark"></div>
                        </div>
                        <div style="padding-left:5px" class="dt-checkbox-label">{{ $t('all_undelivered') }}</div>
                    </div>
                </div>


                <TextField v-if="!all_undelivered" type="date" v-bind="textFieldConfig" @validated="onValidation" required
                    id="release_start" class="m1" :placeholder="$t('release_start')" :value="release_start"
                    autocomplete="off" @valuechanged="onTextFieldValueChange" />
                <TextField v-if="!all_undelivered" type="date" v-bind="textFieldConfig" @validated="onValidation" required
                    id="release_end" class="m1" :placeholder="$t('release_end')" :value="release_end" autocomplete="off"
                    @valuechanged="onTextFieldValueChange" />
                <Dropdown :options="packageSizeTV" :id="'package_size'" class="m2"
                    :selected="packageSizeTV.find(e => e.value == package_size)" :placeholder="$t('package_size')"
                    @selectedChange="e => onDropdownChange('package_size', e)" box :listHeight="250"></Dropdown>



            </div>
        </template>
        <template slot="options">

            <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
            <button class="dt-button s6 v1" :class="{ disabled: !isFormValid }" :disabled="!isFormValid"
                @click.stop="onContinue">
                Continue
            </button>
        </template>
    </Modal>
    </v-dialog>
</div>`,
    script: `window.PluginData = {

        data: function () {
            return {
                textFieldConfig: {
                    height: 42,
                    showEditIconOnHover: false,
                    box: true,
                    showValidationIcons: true,
                    immediateValidation: true,
                },
                statuses: [],
                all_undelivered: false,
                api_account: '',
                label_ids: '',
                label_filter_id: '',
                release_start: '',
                release_end: null,
                package_size: 25,
                loading: false,
                labels: [],
                validationResult: {},
                proAgencyData: null,
                pluginFlag:false
            };
        },
        mounted: async function () {
            const proAgencyData = await window.HttpClient.get('/label.pl', {
                section: "plugin",
                action: "pro_agency_delivery_modal_data"
            });
            console.log("WERE", proAgencyData);
            this.proAgencyData = proAgencyData.data;
        },
        computed: {
            isFormValid: function () {
                return this.all_undelivered ? true : Object.values(this.validationResult).every(e => e.valid);
            },
            labelsTV: function () {
                return this.proAgencyData?.pro_agency_accounts[0]?.labels.map(e => {
                    return {
                        text: e.label_name,
                        value: e.label_id
                    };
                }).filter(e => e.text != "") || [];
            },
            api_accountsTV: function () {
                return this.proAgencyData?.api_accounts?.map(e => {
                    return {
                        text: e.account,
                        value: e.account
                    };
                }) || [];
            },
            packageSizeTV: function () {
                return [{ text: 25, value: 25 }, { text: 50, value: 50 }, { text: 100, value: 100 }, { text: 250, value: 250 }, { text: 'All', value: 'all' }]
            },
    
    
        },
        methods: {
            changeCheckbox(e) {
                console.log('/////',e)
                this.all_undelivered = e.target.checked;
    
            },
            onValidation: function (name, value) {
                this.$set(this.validationResult, name, value);
                console.log(this.validationResult);
            },
            onAddProAgency:function () {
               this.pluginFlag=true;
            },
            onTextFieldValueChange: function (key, value) {
                this[key] = value
            },
            onCancel: function () {
                this.pluginFlag=false;
            },
            onContinue: function () {
                if (this.all_undelivered) {
                    const url=window.HttpClient.getBaseUrl()+"/"+this.proAgencyData.v2_url_hash_part+"/pro-agency-data-transfer?api_account="+this.api_account+'&label_ids='+this.proAgencyData.pro_agency_accounts[0].label_ids+'&label_filter_id='+this.label_filter_id+'&limit='+this.package_size;
                    window.open(url, '_blank');
                }
                else {
                    const url=window.HttpClient.getBaseUrl()+"/"+this.proAgencyData.v2_url_hash_part+"/pro-agency-data-transfer?api_account="+this.api_account+'&label_ids='+this.proAgencyData.pro_agency_accounts[0].label_ids+'&label_filter_id='+this.label_filter_id+'&limit='+this.package_size+'&start='+this.release_start+'&end='+this.release_end;
                    window.open(url, '_blank');
                }
                this.pluginFlag=false;
    
            },
            onDropdownChange: function (name, value) {
    
                this[name] = value.value
    
    
            },
    
            //MARK: Methods
        }
    }`
};

export const _BandCamp = {
    name: "BandCamp",
    template: `<div>
    <button :class="{disabled: loadingGif}" :disabled="loadingGif"
       @click="onClickBandCamp"
       style="min-width: 150px"
       class="dt-button v5 s8"
       >
       <template v-if="loadingGif">
          <img src="static/icons/loading.gif" />
       </template>
       <template v-else> GET BANDCAMP ORDERS({{
          bandCampResponse.ordersArray.length
          }})
       </template>
    </button>
    <v-dialog v-model="bandcampFlag" persistent width="1200">
       <Modal @cancelled="onCancel"
          :id="'cmp-distribution-imports-file_uploader'"
          >
          <template slot="header"></template>
          <template slot="body">
             <div  style="height:300px" class="cm-multi-order-list-container dbox">
                <NTable 
                   v-if="!next"
                   style="height:300px"
                   :config="tableConfig"
                   :headers="headers" 
                   :items="bandcampList" 
                   class="multi-order-list h1 dbox1" 
                   @scrollnext="onListScroll"
                   >
                   <template v-slot:item="{ item, tdcon }">
                      <tr>
                         <td  v-bind="tdcon('artist')">
                            <span>{{item['bandcamp_items'][0].artist}}</span>
                         </td>
                         <td v-bind="tdcon('title1')">
                            <span>{{item['bandcamp_items'][0].item_name}}</span>
                         </td>
                         <td v-bind="tdcon('sku')">
                            <span>{{item['bandcamp_items'][0].sku}}</span>
                         </td>
                         <td v-bind="tdcon('catalog_no')">
                            <Dropdown
                               id="catalog_no"
                               :options="productsTV"
                               class="search-container-dropdown"
                               isSearchable
                               :disabled="false"
                               :showLabel="false"
                               @selectedChange="(e) => onAutocompleteSelected('catalog_no',e,item)"
                               :selected="getSelected(item)"
                               @searched="onDropdownSearch"
                               />
                         </td>
                      </tr>
                   </template>
                </NTable>
                <NTable
                   v-else
                   class="multi-order-list11 h1 dbox1" 
                   :headers="headersTable"
                   :items="bandcampList"
                   :config="tableConfig"
                   @scrollnext="onListScroll"
                   >
                   <template v-slot:thead="{ thcon, thtext }">
                      <tr>
                         <th
                            v-for="header in headersTable"
                            v-bind="thcon(header.value)"
                            :key="header.value"
                            >
                            <div v-if="header.value=='chk'"  class="header-name">
                               <div  style="display: flex;
                                  justify-content: center;
                                  cursor: pointer;" class="dt-checkbox v2 s1"   >
                                  <input
                                     @click="e=>onCheckboxChangeAll(e)"
                                     type="checkbox"
                                     name="name"
                                     :checked="selectAllNone"
                                     />
                                  <div class="checkmark"></div>
                               </div>
                            </div>
                            <div v-else-if="header.value=='exclude_for_label'" style="margin-top:10px;display:flex" class="header-name">
                               <div>{{thtext(header.value)}}</div>
                               <div style="margin-top:-4px">
                                  <img class="arrow"
                                     width="30"
                                     height="30"
                                     src="static/icons/question.svg"
                                     alt 
                                     />
                               </div>
                            </div>
                            <div v-else class="header-name">
                               {{thtext(header.value)}}
                            </div>
                         </th>
                      </tr>
                   </template>
                   <template v-slot:item="{ item, tdcon }">
                      <tr>
                         <td v-if="!exportClick" v-bind="tdcon('chk')">
                            <div class="checkbox-container">
                               <div class="dt-checkbox v2 s1">
                                  <input
                                     type="checkbox"
                                     name="name"
                                     :checked="selectedProducts.has(item.product_checked_id)"
                                     @click="e => onCheckboxChange(e, 'name', item)"
                                     />
                                  <div class="checkmark"></div>
                               </div>
                            </div>
                         </td>
                         <td v-bind="tdcon('order_date')">
                            <span >{{item['order_date']}}</span>
                         </td>
                         <td v-bind="tdcon('bandcamp_order')">
                            <span >{{item['order_reference']}}</span>
                         </td>
                         <td v-bind="tdcon('customer')">
                            <span >{{item['order_source']}}</span>
                         </td>
                         <td v-bind="tdcon('city')">
                            <span >{{item['deliver_city']}}</span>
                         </td>
                         <td v-bind="tdcon('country')">
                            <span>{{item['deliver_country']}}</span>
                         </td>
                      </tr>
                   </template>
                </NTable>
             </div>
          </template>
          <template slot="options">
             <button @click="onCancel" class="dt-button s6" >Cancel</button>
             <button v-if="!next" :class="{
                disabled: okButtonDisabled
                }" :disabled="okButtonDisabled" @click="onOKClick" class="dt-button v1  s6">
             OK
             </button>
             <button v-if="next"  @click="onSaveClick" class="dt-button v1  s6">
             OK
             </button>
          </template>
       </Modal>
    </v-dialog>
 </div>

`,

    script: `window.BandCamp = {

        data() {
            return {
                bandcampList: [],
                rowCount: 100,
                start: 0,
                selectedArray: [],
                productsTV: [],
                bandcampFlag: false,
                scrollSubject: window.Subject,
                bandCampResponse: { ordersArray: [] },
                loadingGif: true,
                next: false,
                tableConfig: window.createNTableConfig({
                    headerStyle: 3,
                    fullHeight: true
                }),
                selectedProducts: new Set(),
                exportClick: false,
                selectAllNone: false,
            }
        },
        computed: {
            okButtonDisabled: function () {
                return this.bandCampResponse?.ordersArray.length !== this.selectedArray.length ? true : false;
            },
            list2: function () {
                return this.bandCampResponse?.ordersArray || [];
            },
            list: function () {
                return this.bandCampResponse.ordersArray || [];
            },
            headersTable: function () {
                return [
                    window.createTableHeader("chk", { text: false, mw: 30 }),
                    window.createTableHeader("order_date"),
                    window.createTableHeader("bandcamp_order"),
                    window.createTableHeader("customer"),
                    window.createTableHeader("city",),
                    window.createTableHeader("country",),
                ];

            },
            headers: function () {
                return [
                    window.createTableHeader("artist", { f: 1 }),
                    window.createTableHeader("title1", { text: 'title', f: 2.5 }),
                    window.createTableHeader("sku", { f: 1 }),
                    window.createTableHeader("catalog_no", { f: 1 }),

                ];
            },
        },
        async mounted() {
            this.loadData();

        },
        methods: {
            async loadData() {
                const resData = await window.HttpClient.get('/distribution.pl', {
                    section: "orders",
                    action: "get_product_for_bandcamp_order_modal",
                    search: null
                });
                console.log("resData", resData);
                this.productsTV = resData.data.products.map(p => {
                    return {
                        text: p.catalog_no,
                        value: p.product_id,
                    }
                });


                const bandCampData = await window.HttpClient.get('/distribution.pl', {
                    section: "orders",
                    action: "get_orders_from_bandcamp"
                });
                
                console.log(bandCampData, "bandCampData");
                const objKeyArray = Object.keys(bandCampData.data.response);
                console.log("bandCampData :::", objKeyArray);
                const objKey = objKeyArray[0];
                let bandCampResponse = { ...bandCampData.data.response[objKey] };
                [...Object.values(bandCampResponse.orders)].forEach((order, index) => {
                    order.key = [...Object.keys(bandCampResponse.orders)][index]
                });
                this.bandCampResponse = {
                    ...bandCampResponse,
                    ordersArray: [...Object.values(bandCampResponse.orders)],
                    response: bandCampData.data.response,
                    objKey: objKey
                };
                console.log(bandCampResponse, "bandCampData");
                this.loadingGif = false;

                this.bandcampList = this.bandCampResponse?.ordersArray.slice(0, 100) || [];
                window.subscribeSubject(this, this.scrollSubject, (res) => {
                    this.bandcampList = [...this.bandcampList, ...this.bandCampResponse?.ordersArray.slice(res.start, res.rowCount)]
                    console.log("STRING SER", res);
                });
            },
            onCheckboxChangeAll: function (e) {
                if (!this.selectAllNone) {
                    this.selectAllNone = true;
                    this.bandCampResponse?.ordersArray.forEach((item, index) => {
                        item['product_checked_id'] = item['product_id'] + '_' + item['order_reference'];
                    })
                    this.selectedProducts = new Set(this.bandCampResponse?.ordersArray.map(e => e.product_checked_id));

                } else {
                    this.selectAllNone = false;
                    this.selectedProducts = new Set();
                    this.bandCampResponse?.ordersArray.forEach((item, index) => {
                        item['product_checked_id'] = "";
                    })
                }
            },

            onListScroll: function (value) {
                console.log("OOO")
                this.start = this.rowCount
                this.rowCount += this.rowCount
                this.scrollSubject.next({ rowCount: this.rowCount, start: this.start });
            },
            onCheckboxChange: function (event, name, item) {
                const value = event.target.checked;
                item['product_checked_id'] = item['product_id'] + '_' + item['order_reference'];
                this.selectedProducts = window.addRemoveSet(
                    event.target.checked,
                    this.selectedProducts,
                    item.product_checked_id
                );
                item['product_checked_id'] = event.target.checked ? item['product_id'] + '_' + item['order_reference'] : '';
                console.log("WWWW", this.selectedProducts, item);
                this.selectAllNone = this.selectedProducts.size === this.bandCampResponse?.ordersArray.length ? true : false;
            },
            getSelected: function (item) {
                console.log('item', item)
                const key = item['bandcamp_items'][0].package_id + '-' + item['bandcamp_items'][0].payment_id
                const selectedItem = this.selectedArray.find(e => e.key == key)
                if (selectedItem) {
                    return this.productsTV.find(e => e.value == selectedItem.value)
                }
                return undefined

            },
            onAutocompleteSelected: function (name, value, item) {
                console.log(name, value)
                item['product_id'] = value.value;
                item['product_checked_id'] = value.value + '_' + item['order_reference'];
                const key = item['bandcamp_items'][0].package_id + '-' + item['bandcamp_items'][0].payment_id;
                this.selectedArray = this.selectedArray.filter(a => a.key !== key)
                if (this.selectedArray.length > 0) {
                    this.selectedArray = [...this.selectedArray, { key: key, value: value.value }]
                } else {
                    this.selectedArray = [{ key: key, value: value.value }]
                }
                this.selectedProducts = window.addRemoveSet(
                    true,
                    this.selectedProducts,
                    item.product_checked_id
                );
                this.selectAllNone = this.selectedProducts.size === this.bandCampResponse?.ordersArray.length ? true : false;
                this.bandCampResponse?.ordersArray.forEach(order => {
                    if (order.product_checked_id === item.product_checked_id) {
                        order.orderlines.forEach(orderline => {
                            orderline.external_id = item.product_id;
                            if (orderline.metadata) {
                                orderline.metadata.external_id = item.product_id;
                            }
                            if (orderline.relation) {
                                orderline.relation.external_id = item.product_id;
                            }
                        })
                    }
                });

            },
            onDropdownSearch: async function (e) {
                console.log(":::::", e)
                const resData = await window.HttpClient.get('/distribution.pl', {
                    section: "orders",
                    action: "get_product_for_bandcamp_order_modal",
                    search: e
                });
                console.log("resData", resData);
                this.productsTV = resData.data.products.map(p => {
                    return {
                        text: p.catalog_no,
                        value: p.product_id,
                    }
                })
            },
            onCancel: function () {
                this.bandcampFlag = false;
            },
            onOKClick: function () {
                this.next = true;
            },
            onAllCheckboxChange() {
                this.selectAllNone = !this.selectAllNone;
            },
            async onSaveClick() {
                const orders = this.bandCampResponse.ordersArray.filter(o => o.product_checked_id !== '');
                console.log('oders', orders);
                console.log('bandCampResponse', this.bandCampResponse);
                let new_results = {};
                orders.forEach(order => {
                    new_results[this.bandCampResponse.objKey] = new_results[this.bandCampResponse.objKey] || {};
                    new_results[this.bandCampResponse.objKey].orders = new_results[this.bandCampResponse.objKey].orders || {};

                    new_results[this.bandCampResponse.objKey].start_date_time = this.bandCampResponse.response[this.bandCampResponse.objKey].start_date_time;
                    new_results[this.bandCampResponse.objKey].orders[order.key] = {
                        ...order
                    };
                });
                console.log('new_results', new_results)
                window.NotificationService.showNotification({
                    text: "importing data",
                    timeout: 1000,
                    type: "success",
                });
                const bandCampData = await window.HttpClient.get('/distribution.pl', {
                    section: "orders",
                    action: "save_bandcamp_orders",
                    results: JSON.stringify(new_results)
                });

                console.log('aaa', bandCampData)
                const msg = bandCampData.data.status.total_orders + 'orders and' + bandCampData.data.status.total_orderlines + 'order lines are added successfully!'
                window.NotificationService.showNotification({
                    text: msg,
                    timeout: 2000,
                    type: "success",
                });
                this.loadingGif = true;
                this.loadData();
                this.onCancel();

            },
            async onClickBandCamp() {
                if (this.bandCampResponse.ordersArray.length > 0) {
                    this.bandcampFlag = true;
                } else {
                    window.NotificationService.showNotification({
                        text: "Currently there are no new orders.Checking again ...",
                        timeout: 2000,
                        type: "normal",
                    });
                }
            }
        }
    }`}




